module.exports = __webpack_public_path__ + "img/banner3.fa9b03e7.png";